import React, { useState } from 'react';
import * as classnames from 'classnames';

import './styles.scss';

const HeaderBurger = ({active}) => {
	const [isActive, setIsActive] = useState(false)

	const handleClick = () => {
		setIsActive(!isActive);
		active(!isActive);
	}
	return (
		<div 
			className={
				classnames('burger', {
					'burger--active': isActive,
				})
			}
			onClick={handleClick}
		>
			<div className="burger__line burger__line--top"></div>
			<div className="burger__line burger__line--middle"></div>
			<div className="burger__line burger__line--bottom"></div>	
		</div>
	);
};

export default HeaderBurger;
